export const getIPAddress = async () => {
    const response = await fetch('https://api.ipify.org/')

    return response.text()
}
